var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.$apollo.loading)?_c('div',[(!_vm.users.length === 0)?_c('no-data',[_vm._v("登録済みのユーザーがいません")]):_c('simple-table',[_c('thead',[_c('tr',[_c('th',[_vm._v("ID")]),_c('th',[_vm._v("グループ名")]),_c('th',[_vm._v("権限")]),_c('th',{staticClass:"w-full"},[_vm._v("ユーザー名")]),_c('th',[_vm._v("メールアドレス")])])]),_c('tbody',_vm._l((_vm.users),function(ref){
var id = ref.id;
var loginId = ref.loginId;
var name = ref.name;
var type = ref.type;
var role = ref.role;
var group = ref.group;
var email = ref.email;
return _c('tr',[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(loginId))]),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(group.name))]),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(role))]),_c('td',[_c('router-link',{attrs:{"to":{ name: 'user-details', params: { userId: id } }}},[_vm._v(_vm._s(name))])],1),_c('td',[_vm._v(_vm._s(email))])])}),0)])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }